import React from "react";
import { components } from "react-select";

function isMultiValueChild(child) {
    if (!React.isValidElement(child)) {
        return false;
    }
    return child.type === components.MultiValue;
}

function withoutMultiValueChildren(children) {
    return React.Children.toArray(children).filter((child) => !isMultiValueChild(child));
}

export function HandleSelect(selected,value, setSelected, allOptions, withSelectAll){
    // console.log(JSON.stringify(selected)+"selected")
    // console.log(JSON.stringify(value)+"value")
    // console.log(JSON.stringify(setSelected)+"setSelected")
    // console.log(JSON.stringify(allOptions)+"allOptions")
    // console.log(JSON.stringify(withSelectAll)+"withSelectAll")
   
    // Determine the changed option (added or removed)
    const currentValue = Array.isArray(value) ? value : [];
    const changedOption = (selected || []).find((item) => !currentValue.includes(item));

    const selectAllOption = withSelectAll.find((item) => item.value === "select-all");

    if (changedOption !== undefined && changedOption.value === "select-all") {
        setSelected(selectAllOption ? [selectAllOption] : withSelectAll);
    }
    else {
        const areAllSelected = () => allOptions.every((option) =>
            selected ? selected.some((s) => s.value === option.value) : false,
        );

        const selectAllActive = (value || []).some((item) => item.value === "select-all");

        if (areAllSelected()) {
            if (changedOption === undefined && !selectAllActive) {
                setSelected([]);
            } else {
                setSelected(selectAllOption ? [selectAllOption] : withSelectAll);
            }
        }
        else if (selectAllActive) {
            if (!selected || selected.length === 0) {
                setSelected([]);
            } else {
                const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
                setSelected(withoutSelectAll);
            }
        }
        else {
            const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
            setSelected(withoutSelectAll);
        }
    }
};

// export function ValueContainer ({ children, ...props }){
// IMPORTANT NOTE: This code is working good but react-select won't close when clicking outside the react select dropdown
//     // Calculate the count of selected items using props
//     const selectedCount = props.getValue().length;
//     const withoutSelectAllLength = props.getValue().filter((item) => item.value !== 'select-all').length;
//     // Access the placeholder from selectProps
//     const placeholder = props.selectProps.placeholder;
//     return (
//       <components.ValueContainer {...props}>
//         {selectedCount === 0
//           ? placeholder
//           : selectedCount === props.options.length
//           ? `All selected (${withoutSelectAllLength})`
//           : `${selectedCount} selected`}
//       </components.ValueContainer>
//     );
// };

export function ValueContainer({ children, ...props }) {
    const { getValue, options } = props;
    const selected = getValue() || [];
    const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
    const realOptions = (options || []).filter((item) => item.value !== "select-all");

    const selectAllActive = selected.some((item) => item.value === "select-all");
    const selectedCount = selectAllActive ? realOptions.length : withoutSelectAll.length;
    const hasSelection = selectAllActive || withoutSelectAll.length > 0;

    const isAllSelected = realOptions.length > 0 && (
        selectAllActive
        || withoutSelectAll.length === realOptions.length
    );

    const summary = !hasSelection
        ? null
        : isAllSelected
            ? `All selected (${selectedCount})`
            : `${selectedCount} selected`;

    const displayChildren = withoutMultiValueChildren(children);
    const menuOpen = Boolean(props.selectProps.menuIsOpen);

    return (
        <components.ValueContainer {...props}>
            <div style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: 28,
                maxHeight: 28,
                flexWrap: "nowrap",
                overflow: "hidden",
            }}>
                {summary ? (
                    <span
                        style={{
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flexShrink: menuOpen ? 1 : 0,
                            maxWidth: menuOpen ? "46%" : "100%",
                            marginRight: 4,
                            fontSize: 13,
                        }}
                    >
                        {summary}
                    </span>
                ) : null}
                <div style={{
                    flex: !hasSelection || menuOpen ? "1 1 auto" : "0 1 24px",
                    minWidth: !hasSelection || menuOpen ? 72 : 24,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                }}>
                    {displayChildren}
                </div>
            </div>
        </components.ValueContainer>
    );
}

export function CompactMultiValue() {
    return null;
}

let lastOptionToggle = { value: null, at: 0 };

function isDuplicateToggle(value) {
    const now = Date.now();
    if (lastOptionToggle.value === value && now - lastOptionToggle.at < 400) {
        return true;
    }
    lastOptionToggle = { value, at: now };
    return false;
}

function selectionSnapshot(selectProps) {
    const selected = Array.isArray(selectProps.value) ? selectProps.value : [];
    const options = selectProps.options || [];
    const realOptions = options.filter((item) => item.value !== "select-all");
    const selectAllOption = options.find((item) => item.value === "select-all");
    const withoutSelectAll = selected.filter((item) => item.value !== "select-all");
    const selectAllActive = selected.some((item) => item.value === "select-all")
        || (realOptions.length > 0 && withoutSelectAll.length === realOptions.length);
    return { realOptions, selectAllOption, withoutSelectAll, selectAllActive };
}

export function SearchableInput(props) {
    return (
        <components.Input
            {...props}
            placeholder={props.selectProps.menuIsOpen ? "Search" : ""}
        />
    );
}

export function Option(props) {
    const { data, selectProps, isSelected, innerProps, isDisabled } = props;
    const { realOptions, selectAllOption, withoutSelectAll, selectAllActive } = selectionSnapshot(selectProps);
    const checked = data.value === "select-all" ? selectAllActive : (selectAllActive || isSelected);

    const applySelection = (next, action) => {
        selectProps.onChange(next, { action, option: data });
    };

    const toggleOption = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (isDisabled || isDuplicateToggle(data.value)) {
            return;
        }
        if (data.value === "select-all") {
            applySelection(
                selectAllActive ? [] : (selectAllOption ? [selectAllOption] : realOptions),
                selectAllActive ? "deselect-option" : "select-option",
            );
            return;
        }
        if (selectAllActive) {
            applySelection(
                realOptions.filter((option) => option.value !== data.value),
                "deselect-option",
            );
            return;
        }
        const alreadySelected = withoutSelectAll.some((item) => item.value === data.value);
        if (alreadySelected) {
            applySelection(
                withoutSelectAll.filter((item) => item.value !== data.value),
                "deselect-option",
            );
            return;
        }
        const next = [...withoutSelectAll, data];
        const allNow = realOptions.length > 0 && realOptions.every((option) =>
            next.some((item) => item.value === option.value)
        );
        applySelection(
            allNow && selectAllOption ? [selectAllOption] : next,
            "select-option",
        );
    };

    const keepMenuOpen = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <components.Option
            {...props}
            isSelected={checked}
            innerProps={{
                ...innerProps,
                onMouseDown: toggleOption,
                onTouchEnd: toggleOption,
                onClick: keepMenuOpen,
            }}
        >
            <input
                type="checkbox"
                checked={checked}
                readOnly
                tabIndex={-1}
                onChange={() => null}
                style={{ marginRight: 8, pointerEvents: "none" }}
            />
            <span>{data.label}</span>
        </components.Option>
    );
}

export const reportMultiSelectComponents = {
    Option,
    ValueContainer,
    Input: SearchableInput,
    MultiValue: CompactMultiValue,
};

export const multiSelectSearchStyles = {
    valueContainer: (base) => ({
        ...base,
        flexWrap: "nowrap",
        overflow: "hidden",
        maxHeight: 36,
        paddingTop: 2,
        paddingBottom: 2,
    }),
    multiValue: (base) => ({
        ...base,
        display: "none",
    }),
    input: (base) => ({
        ...base,
        minWidth: "24px",
        width: "100%",
        margin: 0,
        padding: 0,
    }),
    control: (base, state) => ({
        ...base,
        minHeight: 40,
        borderColor: state.isFocused ? "#2684ff" : base.borderColor,
        boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : base.boxShadow,
        overflow: "hidden",
    }),
    menu: (base) => ({
        ...base,
        zIndex: 5,
    }),
};

export const reportFilterSelectStyles = {
    ...multiSelectSearchStyles,
    container: (base) => ({
        ...base,
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
    }),
    control: (base, state) => ({
        ...base,
        minHeight: 34,
        maxHeight: 34,
        fontSize: 12,
        borderColor: state.isFocused ? '#6b93ef' : '#c5d9ee',
        background: '#f8fbff',
        boxShadow: state.isFocused ? '0 0 0 1px #6b93ef' : base.boxShadow,
        overflow: 'hidden',
    }),
    valueContainer: (base) => ({
        ...multiSelectSearchStyles.valueContainer(base),
        maxHeight: 32,
        padding: '0 6px',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 20,
        fontSize: 12,
    }),
    placeholder: (base) => ({
        ...base,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    }),
};
